import { useDispatch, useSelector } from 'react-redux';
import { coreStore } from '@/redux';

export type RootState = ReturnType<typeof coreStore.getState>;

export type AppDispatch = typeof coreStore.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
